import EfImg from 'elem/ui/ef-img';
import styles from './index.module.scss';
import { useLang } from '@/i18n';


export const ArrowIcon = (props: any) => (
    <svg width="0.5384em" height="1em" viewBox="0 0 7 13" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1 1.5L6 6.5L1 11.5" stroke={props?.color || '#010101'} strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);
const Content = ({ onChange }: { onChange: (index: number) => void }) => {
    const { t } = useLang('rule');
    const list = [
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1785135860549/1.png',
            title: t('Statement_list_title1'),
            desc: t('Statement_list_desc1'),
        },
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1785135835660/2.png',
            title: t('Statement_list_title2'),
            desc: t('Statement_list_desc2'),
        },
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1785135841128/3.png',
            title: t('Statement_list_title3'),
            desc: t('Statement_list_desc3'),
        },
    ];
    return (
        <div className={styles.content}>
            <div className="content-box">
                <div className="title">{t('Statement_title')}</div>
                <div className="desc">{t('Statement_desc')}</div>
            </div>
            <div className="list">
                {list.map((item, index) => (
                    <div className="item" key={index}>
                        <div className="item-img">
                            <EfImg pc={item.img} />
                        </div>
                        <div className="item-title">{item.title}</div>
                        <div className="item-desc">{item.desc}</div>
                        <a className="item-btn" onClick={() => onChange(index + 1)}>
                            {t('Statement_LearnMore')}
                            <ArrowIcon />
                        </a>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Content;
